<template>
  <div class="Empty" :class="[{ suspended: isSuspended }]">
    <!-- Title -->
    <h1 class="Empty__title" :class="[{ 'Empty__title--404': !isSuspended }]">
      {{ title }}
    </h1>

    <!-- Text -->
    <p class="Empty__text">
      {{ translate('text') }}
    </p>

    <!-- Contact burron -->
    <ElButton type="primary" size="normal" icon="circle icon-Right-Arrow-2" round @click="contact">
      <span class="text-white">
        {{ translate('button') }}
      </span>
    </ElButton>
  </div>
</template>

<script>
var _vm = null

export default {
  name: 'ModelNotFound',

  metaInfo() {
    const brand =
      this.$store.getters['whitelabel/is_whitelabel'] && this.$store.getters['whitelabel/name']
        ? this.$store.getters['whitelabel/name']
        : 'Flaminjoy'
    return {
      title: 'Access restricted',
      titleTemplate: (titleChunk) => {
        return `${_vm ? _vm.titlePage : titleChunk} | ${brand}`
      },
    }
  },

  computed: {
    isAuth() {
      return this.$store.getters['auth/is_auth']
    },

    isSuspended() {
      return this.$route.name === 'suspended'
    },

    page() {
      return (this.isSuspended && 'suspended') || (this.isAuth && 'auth') || 'nonauth'
    },

    title() {
      return (this.isSuspended && this.translate('title')) || 'Access restricted'
    },

    titlePage() {
      return (this.isSuspended && 'Suspended') || 'Access restricted'
    },
  },

  created() {
    _vm = this
  },

  methods: {
    contact() {
      if (this.isSuspended) {
        window.location.href = '/contact'
      } else if (this.isAuth) {
        this.$router.push({ name: 'dashboard' })
      } else {
        window.location.href = '/'
      }
    },

    translate(what) {
      return this.$t(`notfound.${what}.${this.page}`)
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/sass/pages/_empty.scss';
</style>
